module.exports = __webpack_public_path__ + "img/troy.dbe7685c.png";